var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"border px-3 py-1",staticStyle:{"background-color":"rgb(135 203 22 / 13%)","height":"40px"}},[_c('p',{staticClass:"text-muted mt-1 mb-0"},[_vm._v("\n      "+_vm._s(_vm.$t('info_climates.data_comparison'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }